import EmptySimImage from '@src/assets/images/emptySim.png';
import { Typography } from 'antd';
type EmptySimProps = {
    title?: string;
    description?: string;
};
export const EmptyState = ({ title, description }: EmptySimProps) => {
    return (
        <div className="flex flex-col md:flex-row w-full h-auto md:h-[450px] pl-0 md:pl-8">
            <div className="w-full md:w-3/5 pt-8 md:px-8">
                {title && (
                    <Typography.Title level={2}>{title}</Typography.Title>
                )}
                {description && (
                    <Typography.Title level={4}>{description}</Typography.Title>
                )}
            </div>
            <div className="flex items-end justify-end w-full md:w-2/5">
                <img
                    src={EmptySimImage}
                    alt="Map"
                    className="w-auto h-auto max-w-full max-h-full object-contain rounded-xl"
                />
            </div>
        </div>
    );
};
